(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["collection"]) return;
  try {
    
  $(document).ready(function(e){
    $('.qty-down').click(function(e){
      var $input = $(this).parent().find("[name='quantity']");
      var val = parseInt($input.val()) - 1
      $input.val(val);
    });
		$('.qty-up').click(function(e) {
			var $input = $(this).parent().find("[name='quantity']");
			var val = parseInt($input.val()) + 1;
			$input.val(val);
		})
  });

  } catch(e) { console.error(e); }
})();

})();
